import { useEffect, useState } from "react";
import api from "../utils/api";
import { Outlet, Navigate } from "react-router-dom";

export default function RoleRoute({ allow }) {
  const [role, setRole] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    api
      .get("/users/me", { withCredentials: true })
      .then((res) => setRole(res.data.role))
      .catch(() => setRole(null))
      .finally(() => setLoading(false));
  }, []);

  if (loading) return null;

  if (!role || !allow.includes(role)) {
    return <Navigate to="/dashboard" replace />;
  }

  return <Outlet />;
}
